export const quotes = [
  {
    id: 1,
    text: "Life isn't about finding yourself. Life is about creating yourself.",
    author: "George Bernard Shaw"
  },
  {
    id: 2,
    text:
      "The most important thing is to enjoy your life - to be happy - it's all that matters.",
    author: "Audrey Hepburn"
  },
  {
    id: 3,
    text: "Life is really simple, but we insist on making it complicated. ",
    author: "Confucius"
  },
  {
    id: 4,
    text:
      "In the end, it's not the years in your life that count. It's the life in your years.",
    author: "Abraham Lincoln"
  },
  {
    id: 5,
    text:
      "Life is inherently risky. There is only one big risk you should avoid at all costs, and that is the risk of doing nothing.",
    author:
      "We all have two lives. The second one starts when we realize we only have one."
  },
  {
    id: 6,
    text:
      "We all have two lives. The second one starts when we realize we only have one.",
    author: "Tom Hiddleston"
  },
  {
    id: 7,
    text: "You get in life what you have the courage to ask for.",
    author: "Oprah Winfrey"
  },
  {
    id: 8,
    text:
      "People have different reasons for the way they live their lives. You cannot put everyone's reasons in the same box.",
    author: "Kevin Spacey"
  },
  {
    id: 9,
    text:
      "Mellow doesn't always make for a good story, but it makes for a good life.",
    author: "Anne Hathaway"
  },
  {
    id: 10,
    text:
      "When one door closes, another opens; but we often look so long and so regretfully upon the closed door that we do not see the one that has opened for us. ",
    author: "Alexander Graham Bell"
  },
  {
    id: 11,
    text:
      "Work like you don't need the money, love like you've never been hurt and dance like no one is watching.",
    author: "Randall G Leighton"
  },
  {
    id: 12,
    text:
      "To live is the rarest thing in the world. Most people exist, that is all.",
    author: "Oscar Wilde"
  },
  {
    id: 13,
    text:
      "There comes a time when you have to choose between turning the page and closing the book.",
    author: "Josh Jameson"
  },
  {
    id: 14,
    text: "Life is what happens to you while you're busy making other plans.",
    author: "Allen Saunders"
  },
  {
    id: 15,
    text:
      "The purpose of life is not to be happy. It is to be useful, to be honorable, to be compassionate, to have it make some difference that you have lived and lived well.",
    author: "Ralph Waldo Emerson"
  },
  {
    id: 16,
    text:
      "Be not afraid of life. Believe that life is worth living, and your belief will help create the fact.",
    author: "Henry James"
  },
  {
    id: 17,
    text: "Life is 10% what happens to us and 90% how we react to it.",
    author: "Dennis P. Kimbro"
  },
  {
    id: 18,
    text:
      "Many of life's failures are experienced by people who did not realize how close they were to success when they gave up.",
    author: "Thomas Edison"
  },
  {
    id: 19,
    text: "Strive not to be a success, but rather to be of value.",
    author: "Albert Einstein"
  },
  {
    id: 20,
    text:
      "Accept responsibility for your life. Know that it is you who will get you where you want to go, no one else.",
    author: "Les Brown"
  }
];
